import { callReduxAlertAction } from '../App';
import myGlobals from './globals';

function getDefaultState(){
    return ({
        isLoading: true,
        hasError: false,
        data: null
    });
}

function stateSetter(responseObj){
    this.setState({
        isLoading: responseObj.isLoading,
        hasError: responseObj.hasError,
        data: responseObj.data
    });
}

function loadData(url,body, setState){
    let link = url;
    link = myGlobals.initialHost+myGlobals.appender+link;
    fetch(link, {
    //fetch("https://api.jsonbin.io/b/5f05af36a62f9b4b27611c16", {
        //method: "GET"
        method: "POST",
        body: body
    }).then(
        function(response){
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                response.status);
                throw new Error("Status Code: "+response.status);
            }
            return response.json();
        }
        ).then((data)=>{
            setState({
                isLoading: false,
                hasError: false,
                data: data
            });
        }).catch(
        function(err)
        {
            console.log('Fetch Error :-S',err);
            setState({
                isLoading: false,
                hasError: true,
                data: null
            });
        }
    );
}

export const makeFirstCardCall = async (invoiceData, paymentData) => {
	var result;
  let isSurchargeEnabledOnCardBrand = invoiceData.state.isSurchargeEnabledOnCardBrand;
  let isSurchargeThroughAPIEnabled = invoiceData.state.isSurchargeThroughAPIEnabled;
    if (invoiceData.state.paymentOnAccount) {
        const searchParams = new URLSearchParams();
        console.log("customerId : " + invoiceData.state.pkMcarId);
        searchParams.append(
          "supplierId",
          window.rsaEncrypt(invoiceData.state.onDemandAccountId)
        );
        searchParams.append(
          "customerMapId",
          window.rsaEncrypt(invoiceData.state.pkMcarId)
        );
        searchParams.append(
          "currency",
          window.rsaEncrypt(invoiceData.state.currency)
        );
        searchParams.append(
          "paymentAmount",
          window.rsaEncrypt(invoiceData.state.payableAmount)
        );
        searchParams.append("isSupplier", window.rsaEncrypt(true));
        searchParams.append("isSurchargeEnabledOnCardBrand", window.rsaEncrypt(isSurchargeEnabledOnCardBrand));
        searchParams.append("isSurchargeThroughAPIEnabled", window.rsaEncrypt(isSurchargeThroughAPIEnabled));
        let link = !paymentData.state.isDCFlow
          ? "getConvenienceFeeForPaymentOnAccountWithoutLogin"
          : "getConvenienceFeeForDebitCardPOAWithoutLogin";
        link = myGlobals.initialHost + myGlobals.appender + link;
        myGlobals.cardFetchCallCompleted = false;
        await fetch(link, {
          //https://api.jsonbin.io/b/5ebab66ca47fdd6af161fe18/1
          method: "POST",
          body: searchParams,
        })
          .then(function (response) {
            if (response.status !== 200) {
              console.log(
                "Looks like there was a problem. Status Code: " + response.status
              );
              return;
            }
            return response.json();
          })
          .then(function (data) {
            // responseFunction(data, self).catch(() => {});
            myGlobals.cardFetchCallCompleted = true;
            result =  data;
          })
          .catch(function (err) {
            console.log("Fetch Error :-S", err);
            //onFailure(err);
          });
      } else {
        let invoiceNumbers = "";
        invoiceData.state.selectedInvoices.forEach((invoice) => {
          invoiceNumbers += invoice.accountDocHeaderId + ",";
        });
        invoiceNumbers = invoiceNumbers.substring(0, invoiceNumbers.length - 1);
        let invoiceNumberAndAmount = "&&";
        invoiceData.state.selectedInvoices.forEach((invoice) => {
          const payAmount =
            invoice.payableAmount !== undefined && invoice.payableAmount !== null
              ? invoice.payableAmount
              : invoice.payableAmount2;
          invoiceNumberAndAmount +=
            invoice.accountDocHeaderId +
            "@" +
            payAmount +
            '@0@""@""&&';
        });
        invoiceNumberAndAmount = invoiceNumberAndAmount.substring(
          0,
          invoiceNumberAndAmount.length - 2
        );
        const searchParams = new URLSearchParams();
        searchParams.append(
          "supplierId",
          window.rsaEncrypt(invoiceData.state.onDemandAccountId)
        );
        searchParams.append(
          "customerId",
          window.rsaEncrypt(invoiceData.state.pkMcarId)
        );
        searchParams.append(
          "currency",
          window.rsaEncrypt(invoiceData.state.selectedInvoices[0].currency)
        );
  
        let invoiceNumberAndAmountParam = "";
        let length = invoiceNumberAndAmount.length;
        let invoiceNumberAndAmountBackup = invoiceNumberAndAmount;
        let i = 0;
        while (length > 0) {
          if (length > 245) {
            invoiceNumberAndAmountParam =
              invoiceNumberAndAmountParam +
              "||" +
              window.rsaEncrypt(invoiceNumberAndAmountBackup.substring(0, 245));
            invoiceNumberAndAmountBackup = invoiceNumberAndAmountBackup.substring(
              245,
              length
            );
            length = length - 245;
          } else {
            invoiceNumberAndAmountParam =
              invoiceNumberAndAmountParam +
              "||" +
              window.rsaEncrypt(
                invoiceNumberAndAmountBackup.substring(0, length)
              );
            length = 0;
          }
          i = i + 1;
        }
        searchParams.append("selectedBills", invoiceNumberAndAmountParam);
  
        let invoiceNumbersParam = "";
        length = invoiceNumbers.length;
        let invoiceNumbersBackup = invoiceNumbers;
        i = 0;
        while (length > 0) {
          if (length > 245) {
            invoiceNumbersParam =
              invoiceNumbersParam +
              "||" +
              window.rsaEncrypt(invoiceNumbersBackup.substring(0, 245));
            invoiceNumbersBackup = invoiceNumbersBackup.substring(245, length);
            length = length - 245;
          } else {
            invoiceNumbersParam =
              invoiceNumbersParam +
              "||" +
              window.rsaEncrypt(invoiceNumbersBackup.substring(0, length));
            length = 0;
          }
          i = i + 1;
        }
        searchParams.append("selectedArs", invoiceNumbersParam);
        searchParams.append("sourceApp", window.rsaEncrypt("Guest"));
        searchParams.append("isSurchargeEnabledOnCardBrand", window.rsaEncrypt(isSurchargeEnabledOnCardBrand));
        searchParams.append("isSurchargeThroughAPIEnabled", window.rsaEncrypt(isSurchargeThroughAPIEnabled));

        let link = !paymentData.state.isDCFlow
          ? "checkCreditCardForSupplierWithoutLogin"
          : "checkDebitCardForSupplierWithoutLogin";
        link = myGlobals.initialHost + myGlobals.appender + link;
        myGlobals.cardFetchCallCompleted = false;
        // link = "https://api.npoint.io/48c1c71486415cc8472b";
        await fetch(link, {
          //https://api.jsonbin.io/b/5ebab66ca47fdd6af161fe18/1
          method: "POST",
          body: searchParams,
        })
          .then(function (response) {
            if (response.status !== 200) {
              console.log(
                "Looks like there was a problem. Status Code: " + response.status
              );
              return;
            }
            return response.json();
          })
          .then(function (data) {
            // responseFunction(data, self).catch(() => {});
            myGlobals.cardFetchCallCompleted = true;
            result =  data;
          })
          .catch(function (err) {
            console.log("Fetch Error :-S", err);
            //onFailure(err);
          });
      }
    return result;
}

const computeInvoiceMapCommaSeparated = invoiceMap => {
  let invoiceNumbers = [];
  let invoiceAmounts = [];
  [1,2,3,4,5].map(num => {
        let invoiceNumber = invoiceMap["invoice"+num];
        let invoiceAmount = invoiceMap["invoice-amount"+num];
       if(invoiceNumber && invoiceAmount && 
          invoiceNumber !== "" &&  invoiceAmount !== "-1") {
            invoiceNumbers.push(invoiceNumber);
            invoiceAmounts.push(invoiceAmount);
          }
  })
  let finalInvoiceMap = {"invoiceNumbers" : invoiceNumbers, "invoiceAmounts" : invoiceAmounts};
  return JSON.stringify(finalInvoiceMap);
}

export const uploadFileToS3 = async (fileName, uploadAttachment) => {
return new Promise (function async(resolve, reject) {
  const searchParams = new FormData();
  searchParams.append("fileName", fileName);
  searchParams.append("token", myGlobals.token);
  searchParams.append("uploadAttachment", uploadAttachment);
  let link = "uploadGuestPayDocument";
  link = myGlobals.initialHost + myGlobals.appender + link;
  let filePath = "";
    fetch(link, {
    method: "POST",
    body: searchParams,
  })
    .then((r) => r.json())
    .then((data) => {
      resolve(data?.rows?.filePath);
    });
  })
};

export const checkAndScanFile = async (fileName, uploadAttachment) => {
  let token = myGlobals.token;

  const searchParams = new URLSearchParams();
  searchParams.append("token", token);
  searchParams.append("fileName", fileName);
  let link = "checkFileScanEnabled";
  link = myGlobals.initialHost + myGlobals.appender + link;
  let scanResult = "failed";

  await fetch(link, {
    method: "POST",
    body: searchParams,
  })
    .then(function (response) {
      if (response.status !== 200) {
        console.log(
          "Looks like there was a problem. Status Code: " + response.status
        );
        throw new Error("Status: " + response.status);
      }
      return response.json();
    })
    .then(async (data) => {scanResult = await scanFile(uploadAttachment, fileName, data)})
    .catch(function (err) {
      console.log("Fetch Error :-S", err);
      callReduxAlertAction(
        "failure.generic.remittance.alert",
        "Validations failed, please enter correct data"
      );
    });

  return scanResult;
}; 

function scanFile(uploadAttachment, fileName, respData) {
  return new Promise (function async(resolve, reject) {
    let fileScanURL = respData?.rows?.fileScanURL;
    if(fileScanURL === undefined || fileScanURL === "") return;
    var xhr = new XMLHttpRequest();
    xhr.open('POST', fileScanURL, true);
    var data = new FormData();
    data.append('file', uploadAttachment, fileName);
    xhr.send(data);

    xhr.onload = function () {
      if (xhr) {
        resolve(xhr.responseText);
      }
    };

  });
}


export const validateStaticInvoiceData = async (invData, invoiceMap, onSuccess, hideCustomerNumber) => {
  let token = invData.state.token;
  const searchParams = new URLSearchParams();
  if(!hideCustomerNumber){
    let customerNumberFromData = JSON.parse(invoiceMap)["customerNumber"];
    let custInvoiceMap = JSON.parse(invoiceMap);

    if(custInvoiceMap.custIdentifier1) searchParams.append("custIdentifier1",custInvoiceMap.custIdentifier1);
    if(custInvoiceMap.custIdentifier2) searchParams.append("custIdentifier2",custInvoiceMap.custIdentifier2);
    if(custInvoiceMap.custIdentifier3) searchParams.append("custIdentifier3",custInvoiceMap.custIdentifier3);
    if(custInvoiceMap.custIdentifier4) searchParams.append("custIdentifier4",custInvoiceMap.custIdentifier4);
    if(custInvoiceMap.custIdentifier5) searchParams.append("custIdentifier5",custInvoiceMap.custIdentifier5);

    searchParams.append("customerNumber", customerNumberFromData);
  }
  let invoiceSpreadSheet = JSON.parse(invoiceMap)["fileName"];
  invoiceMap = computeInvoiceMapCommaSeparated(JSON.parse(invoiceMap));
  searchParams.append("token", token);
  searchParams.append("invoiceMap", invoiceMap);
  searchParams.append("fileName", invoiceSpreadSheet)
  let link = "topBuildValidateInvoice";
  link = myGlobals.initialHost + myGlobals.appender + link;
  fetch(link, {
    method: "POST",
    body: searchParams
  })
    .then(function (response) {
      if (response.status !== 200) {
        console.log(
          "Looks like there was a problem. Status Code: " + response.status
        );
        throw new Error("Status: " + response.status);
      }
      return response.json();
    })
    .then(function (data) {
      onSuccess(data, invData);
    })
    .catch(function (err) {
      console.log("Fetch Error :-S", err);
      callReduxAlertAction(
        "failure.generic.remittance.alert",
        "Validations failed, please enter correct data"
      );
    });
}

export default {
    loadData: loadData,
    stateSetter: stateSetter,
    getDefaultState: getDefaultState,
    makeFirstCardCall: makeFirstCardCall
};